import { logErrorToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { profLoanInsert } from "../../../connection-manager/src/services/profLoanInsert.service";
import { V5 } from "../../../connection-manager/src/services/constants";
import { getApplicationId, getApplicationIdAndProdCode, redirectionInAppWebform } from "./utils";

export const dcHandler: SSORedirectHandler = async (data) => {
  const { mobileNo, custId, custType } = await getSessionData();
  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, ["DC"]);
  const product = "DOCTOR_DEBT";
  let response = undefined;
  const appVersion = V5;
  const dcInsertJourneyName = "LAPPROF_DC_NTB";
  const resume = applicationID !== undefined;

  try {
    response = await profLoanInsert({
      mobileNo,
      custId,
      custType,
      journeyName: dcInsertJourneyName,
      appId: await getApplicationId(["DC"]),
      appVersion,
      prodName: "LAPPROF",
      ...data.data?.debtInsert,
    });
  } catch (error) {
    logErrorToNewRelic(error as string, {
      errorType: "Error in Debt insert",
    });
  }

  if (isOpenInApp()) {
    redirectionInAppWebform(response?.id ?? applicationID ?? "", "DC");
    return;
  }

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);

  redirectToWebform(callbackUrl.toString(), {
    applicationID: response?.id ?? applicationID,
    custType,
    prodCode: response?.id ? "" : prodCode,
    product,
    resume: response?.id || applicationID ? resume : false,
  });
};
